"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsNumber_1 = __importDefault(require("../../typeAssertions/valueIsNumber"));
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const buildCallableCopyClipboard = (args) => async ({ entryVars: { value, }, callbacks, functionId, executeProcesses, }) => {
    try {
        if (!(0, valueIsString_1.default)(value) && !(0, valueIsNumber_1.default)(value)) {
            executeProcesses(functionId, callbacks.onError, 'Invalid value');
            return;
        }
        await args.onCopy(`${value}`);
        executeProcesses(undefined, callbacks.onSucess);
    }
    catch (error) {
        executeProcesses(functionId, callbacks.onError, error);
    }
};
exports.default = buildCallableCopyClipboard;
